/**
 * Guía: Monedas.
 *
 * Contenido derivado del capítulo **03** del manual: §0 (el catálogo maestro,
 * el formato de escritura del dinero y que una moneda es prerrequisito para
 * crear un país).
 *
 * Corta a propósito: es un catálogo. Lo que no es evidente es que el formato
 * decide cómo se escribe **todo** importe de los países que usen esa moneda.
 */

import type { TourFlow } from '../types';

const MONEDAS_PATH = '/currencies';

export const c03Monedas: TourFlow = {
  id: 'admin.currencies',
  chapter: '03',
  title: 'Monedas',
  summary:
    'El catálogo del que cuelgan los países: qué define cada entrada y por qué el formato importa.',
  href: MONEDAS_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Sin monedas no hay países',
      body:
        'Cada país necesita una moneda del catálogo para existir, así que ésta es una de ' +
        'las primeras pantallas que se toca al levantar un entorno desde cero.',
      route: MONEDAS_PATH,
    },
    {
      id: 'format-matters',
      title: 'Aquí se decide cómo se escribe el dinero',
      body:
        'Si el símbolo va antes o después, cuántos decimales lleva y qué separa los miles ' +
        'de los decimales. Ese formato se aplica a **todos** los importes de los países que ' +
        'usen esa moneda: en el panel, en la app y en los informes.',
      target: 'admin.currencies.list',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'delete-guard',
      title: 'No se borra una moneda en uso',
      body:
        'Si algún país la tiene asignada, el borrado se rechaza. Es lo que impide dejar ' +
        'países apuntando a una moneda que ya no existe.',
    },
  ],
};
